import { useEffect, useState } from 'react';
import { useIsFetching } from '@tanstack/react-query';

/**
 * Thin global loading bar for async data fetches.
 * It intentionally ignores very short fetches to avoid flicker.
 */
export const GlobalLoadingIndicator = () => {
  const isFetching = useIsFetching();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isFetching > 0) {
      const t = window.setTimeout(() => setVisible(true), 200);
      return () => window.clearTimeout(t);
    }

    setVisible(false);
    return undefined;
  }, [isFetching]);

  if (!visible) {
    return null;
  }

  return (
    <div
      className="pointer-events-none fixed left-0 top-0 z-[100] h-0.5 w-full overflow-hidden"
      role="status"
      aria-label="Loading"
    >
      <div className="h-full w-1/3 animate-[loading-bar_1.1s_ease-in-out_infinite] bg-primary" />
      <style>{`
        @keyframes loading-bar {
          0% { transform: translateX(-120%); }
          100% { transform: translateX(420%); }
        }
      `}</style>
    </div>
  );
};
